import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createZone({ commit }, item) {
    return this.$axios.$post('admin/zones/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeZone({ commit }, item) {
    return this.$axios.$delete(`admin/zones/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateZone({ commit }, item) {
    return this.$axios.$put(`admin/zones/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchZone({ commit }, id) {
    return this.$axios.$get(`admin/zones/${id}`).then((response) => {
      return response.data
    })
  },
  fetchZones({ commit }) {
    return this.$axios.$get('admin/zones').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
